import type { FaireProductEntity } from "../../entity_types/product";

export const p_e2drtakgj4: FaireProductEntity = {
  token: "p_e2drtakgj4",
  type: "product",
  name: "Thank You Very Much Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/672b21bdaeeb856e49e274aaaa3ad3b516af6955c3627e7d91183723d65d0852.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bace05506556505c7d64238b3f5732a792c6e44d1726ace16d3bfd3761b2f93a.jpeg",
    "https://cdn.faire.com/fastly/85df84e7eb06a9860d81df5431122657f4ec3391a81210a92ab4422dbf06636a.jpeg",
    "https://cdn.faire.com/fastly/45fd0e1fb8da8713cb5c48176e4ea0cecf36658bda99d7c60435c5ce9ca76983.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:03.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
